var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{attrs:{"icon":"el-icon-circle-plus-outline"},on:{"click":_vm.more}},[_vm._v("查看更多")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }